export default "__VITE_ASSET__CRHmyUsM__"